const KNOWN = ['rsi','ema','volume','fibo'] as const

export function listConfluences(cfRaw: any): string[] {
  const cf = cfRaw || {}
  if (!cf || typeof cf !== 'object') return []
  const keys = Object.keys(cf).map(k => k.toLowerCase())
  const out: string[] = []
  const hasRSI = keys.some(k => k === 'rsi' || k.startsWith('rsi_') || k.includes('rsi'))
  if (hasRSI) out.push('RSI')
  const hasEMA = keys.some(k => k === 'ema' || k.startsWith('ema') || k.includes('ema_'))
  if (hasEMA) out.push('EMAs')
  const hasVol = keys.some(k => k.startsWith('vol') || k.includes('volume'))
  if (hasVol) out.push('Volume')
  const hasFibo = keys.some(k => k.startsWith('fib') || k.includes('fibo'))
  if (hasFibo) out.push('Fibonacci')
  return out
}

export function confluencePercent(strength: number, cfRaw: any): number {
  const cf = cfRaw || {}
  const set = new Set<string>(KNOWN as unknown as string[])
  try {
    Object.keys(cf).forEach((k) => {
      const key = k.toLowerCase()
      if (key.includes('ema')) set.add('ema')
      else if (key.includes('rsi')) set.add('rsi')
      else if (key.includes('vol')) set.add('volume')
      else if (key.includes('fibo') || key.includes('fib')) set.add('fibo')
    })
  } catch {}
  const denom = Math.max(4, set.size)
  const pct = Math.round(Math.max(0, Math.min(100, (Number(strength || 0) / denom) * 100)))
  return pct
}

